export default {
  v3SubmitErrBtnViewOrder: 'Voir la commande',
  v3SubmitErrBtnBackHome: 'Accueil',
  v3SubmitErrBtnRetry: 'Réessayer',
  v3SubmitErrBtnRelogin: 'Se reconnecter',
  v3SubmitErrBtnSwitchPay: 'Changer de moyen de paiement',
  v3SubmitErrBtnReorder: 'Repasser commande',
  v3SubmitErrBtnSwitchServer: 'Changer de serveur',
  v3SubmitErrBtnViewOrderStatus: 'Statut de la commande',
  v3SubmitErrBtnBackStore: 'Retourner à la boutique',
  v3SubmitErrBtnGoUpdate: 'Mettre à jour',
  v3SubmitErrBtnResubscribe: 'Réabonner',
  v3SubmitErrTipUpdateApp: 'Mettez à jour via l\'App Store',
  v3SubmitErrTipRelogin: 'Veuillez vous reconnecter',

  v3SubmitErrMsg120009: 'Commande traitée – vérifiez votre inventaire dans le jeu.',
  v3SubmitErrMsg120003: 'Erreur dans les infos du produit – veuillez resélectionner.',
  v3SubmitErrMsg120016: 'Trop de requêtes – attendez quelques secondes et réessayez.',
  v3SubmitErrMsg120025: 'Paramètres de requête anormaux – reconnectez-vous et réessayez.',
  v3SubmitErrMsg121012: 'Canal de paiement temporairement indisponible – essayez un autre moyen.',
  v3SubmitErrMsg120012: 'Réseau instable – vérifiez votre connexion et réessayez.',
  v3SubmitErrMsg120002: 'Aucun personnage de jeu trouvé – veuillez en créer un d\'abord.',
  v3SubmitErrMsg121019: 'Erreur dans les infos de commande – veuillez repasser commande.',
  v3SubmitErrMsg120024: 'Cadeau de préinscription déjà reçu – pas besoin de répéter.',
  v3SubmitErrMsg120000: 'Session expirée – reconnectez-vous.',
  v3SubmitErrMsg120014: 'Numéro de commande invalide – repassez commande.',
  v3SubmitErrMsg121001: 'Recharge dans le jeu échouée – réessayez plus tard ou contactez le support.',
  v3SubmitErrMsg120015: 'Montant de paiement anormal – resélectionnez l\'article.',
  v3SubmitErrMsg120001: 'Serveur incorrect – veuillez passer au bon serveur.',
  v3SubmitErrMsg120020: 'Le canal de paiement a renvoyé une erreur – essayez un autre moyen.',
  v3SubmitErrMsg120010: 'La fonction de recharge est temporairement désactivée – réessayez plus tard.',
  v3SubmitErrMsg120006: 'La vérification du montant a échoué – resélectionnez.',
  v3SubmitErrMsg121010: 'Requête de recharge en sandbox invalide – utilisez la version officielle.',
  v3SubmitErrMsg120017: 'Numéro de commande en double – vérifiez si déjà payé.',
  v3SubmitErrMsg120022: 'La vérification du callback de paiement a échoué – réessayez plus tard.',
  v3SubmitErrMsg121000: 'Système occupé – réessayez plus tard.',
  v3SubmitErrMsg120011: 'ID produit incorrect – resélectionnez.',
  v3SubmitErrMsg121015: 'La vérification du montant du paiement a échoué – repassez commande.',
  v3SubmitErrMsg120004: 'Ce canal de paiement n\'est pas ouvert – choisissez un autre moyen.',
  v3SubmitErrMsg120005: 'Canal de paiement en maintenance – utilisez un autre moyen.',
  v3SubmitErrMsg120007: 'ID plateforme invalide – reconnectez-vous.',
  v3SubmitErrMsg120008: 'Paramètres de requête insuffisants – veuillez renvoyer.',
  v3SubmitErrMsg120013: 'Numéro de commande développeur invalide – repassez commande.',
  v3SubmitErrMsg120018: 'Paiement bloqué par le contrôle des risques – contactez le support pour vérification.',
  v3SubmitErrMsg120019: 'La vérification du nom du package a échoué – utilisez la version officielle.',
  v3SubmitErrMsg120021: 'La vérification de l\'ID produit a échoué – resélectionnez.',
  v3SubmitErrMsg120023: 'Erreur lors de l\'envoi du cadeau de préinscription – vérifiez plus tard.',
  v3SubmitErrMsg120026: 'Compte introuvable – vérifiez l\'état de votre compte.',
  v3SubmitErrMsg120030: 'Stock total insuffisant – choisissez un autre article.',
  v3SubmitErrMsg120031: 'Vous avez dépassé la limite d\'achat pour cet article – ajustez.',
  v3SubmitErrMsg120032: 'Version du jeu trop ancienne – téléchargez la dernière version.',
  v3SubmitErrMsg120080: 'Paiement par agent limité par le contrôle des risques – utilisez votre propre moyen de paiement.',
  v3SubmitErrMsg120081: 'Paiement par agent retardé par le contrôle des risques – vérifiez le résultat plus tard.',
  v3SubmitErrMsg121002: 'Cache de commande invalide – repassez commande.',
  v3SubmitErrMsg121003: 'Configuration de recharge introuvable – contactez le support.',
  v3SubmitErrMsg121004: 'Paramètres étendus insuffisants – renvoyez.',
  v3SubmitErrMsg121005: 'Écriture cache échouée – réessayez plus tard.',
  v3SubmitErrMsg121006: 'Lecture cache échouée – réessayez plus tard.',
  v3SubmitErrMsg121007: 'Erreur de configuration du type de recharge – contactez le support.',
  v3SubmitErrMsg121011: 'Nouveaux champs détectés par Apple – mettez à jour l\'application.',
  v3SubmitErrMsg121013: 'Commande de renouvellement introuvable – réabonnez-vous.',
  v3SubmitErrMsg121014: 'Échec du déchiffrement des paramètres de recharge – renvoyez.',
  v3SubmitErrMsg121017: 'Cette commande a été remboursée – contactez le support pour confirmation.',
  v3SubmitErrMsg121018: 'Abonnement expiré – réabonnez-vous.',
  v3SubmitErrMsg121020: 'Commande annulée – repassez commande.',
  v3SubmitErrMsg121021: 'Erreur de l\'API Google – réessayez plus tard.',
  v3SubmitErrMsg121022: 'Échec d\'obtention du jeton d\'accès – reconnectez-vous.',
  v3SubmitErrMsg121023: 'Statut de commande anormal – vérifiez le statut de crédit.',
  v3SubmitErrMsg121024: 'La confirmation de commande a échoué – réessayez plus tard.'
};
